import { useQuery } from "@tanstack/react-query";
import { PlanType } from "../../../types/planning/plan.type";
import { http } from "../../../utils/httpCommon";
import { shipmentsSchema } from "../../../services/prePlanningService.types";
import { useApiUrls } from "../../useApiUrl";

type UseShipmentsByRouteOrTrapArgs = {
  trailerId: number;
  type: PlanType;
  enabled?: boolean;
};

export const shipmentsByRouteOrTrapKeys = {
  shipmentsByRouteOrTrap: (trailerId: number, type: PlanType) =>
    ["planning", trailerId, type, "trailer-shipments"] as const,
};

export function useShipmentsByRouteOrTrap({
  trailerId,
  type,
  enabled = true,
}: UseShipmentsByRouteOrTrapArgs) {
  const hookUrls = useApiUrls();
  const { getShipmentsByRoute, getShipmentsByTrap } = hookUrls;

  return useQuery({
    queryKey: shipmentsByRouteOrTrapKeys.shipmentsByRouteOrTrap(
      trailerId,
      type
    ),
    queryFn: async () => {
      const url =
        type === "delivery_route"
          ? getShipmentsByRoute(trailerId)
          : getShipmentsByTrap(trailerId);

      const { data } = await http.get(url, { params: { trailerId } });
      return shipmentsSchema.parse(data);
    },
    enabled,
  });
}
